import React from 'react';
import styles from './BookingReservationRoomDetail.module.css';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

interface IBookingReservationRoomDetail {
  roomStatusList: Array<string>;
}

const BookingReservationRoomDetail = ({ roomStatusList }: IBookingReservationRoomDetail) => {
  const { t } = useTranslation();
  return (
    <>
      {roomStatusList.map((status, i) => {
        const roomLabelTextStyle = classNames({ [styles.roomLabelText]: status === 'Cancelled' });
        const roomStatusValueStyle = classNames(
          {
            [styles.roomStatusConfirmedValueText]: status === 'Confirmed' || status === 'Completed'
          },
          { [styles.roomStatusCancelledValueText]: status === 'Cancelled' }
        );
        return (
          <div className={styles.bookingRoomDetailStatusContainer} key={i}>
            <div className={styles.roomLabelContainer}>
              <p>
                <strong className={roomLabelTextStyle}>{`${t('Room')} ${i + 1}`}</strong>
              </p>
            </div>
            <div className={styles.roomValueContainer}>
              <p className={roomStatusValueStyle}>{t(`${status}`)}</p>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default BookingReservationRoomDetail;
